import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './CloseModal.css';
import Button from '../Button';
import { resetForm } from '@store/actions/userManagementAction';
import { useDispatch } from 'react-redux';


interface ModalProps {
  
  closeModal: (value:boolean) => void;
  
 showModal: boolean
 messageToDisplay?:string
}
const CloseModal: React.FC<ModalProps> = ({
  closeModal,
  showModal,
  messageToDisplay
}) => {
    const [show,setShow]=useState<boolean>(showModal);
    const dispatch=useDispatch();
    const closeYes=()=>{
        closeModal(true);
        dispatch(resetForm());
    }
    const closeNo=()=>{
        closeModal(false);
    }
  return (
    <>
      <Modal
        show={show}
        onHide={closeNo}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_page_close_button"
      >
    
        <Modal.Body className="page_modal_body">
        <div className="modal_title">{messageToDisplay?`${messageToDisplay}`: "Do you want to close the form ?"}</div>
        <div className="modal_page_body">
            <Button
              onClick={closeYes}
              disabled={false}
              id=""
              buttonName={'Yes'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
             <Button
              onClick={closeNo}
              disabled={false}
              id=""
              buttonName={'No'}
              colorType={'disabled'}
              icon={''}
              iconPosition={''}
            />
          </div>
            
        </Modal.Body>
        
      </Modal>
    </>
  );
};

export default CloseModal;
